import {
  centralizedBoardAncestorsSelector,
  centralizedBoardLibrarySelector,
  centralizedBoardTitleSelector,
} from '~/store/centralizedBoard/selectors';
import { type AirState } from '~/store/types';
import { getBoardIdFromPath } from '~/utils/PathUtils';

export type PrivateUploadBoardContext = {
  ancestors: ReturnType<typeof centralizedBoardAncestorsSelector>;
  boardId: string | null;
  library: ReturnType<typeof centralizedBoardLibrarySelector>;
  title: ReturnType<typeof centralizedBoardTitleSelector>;
};

/** Read board upload destination from the URL and Redux at call time (not render time). */
export const readPrivateUploadBoardContext = (pathname: string, state: AirState): PrivateUploadBoardContext => ({
  boardId: getBoardIdFromPath(pathname) ?? null,
  title: centralizedBoardTitleSelector(state),
  library: centralizedBoardLibrarySelector(state),
  ancestors: centralizedBoardAncestorsSelector(state),
});
